import ActionType from '../enums/ActionType';

interface ActionRef {
    sowingId?: unknown;
    harvestId?: unknown;
}

export default function actionTypeTitle(type: string, action: ActionRef): string {

    if(type === ActionType.HARVEST) {

        if(action.sowingId) {

            return 'Verzaaiing';
        }

        return 'Levering';
    }

    if(type === ActionType.TREATMENT) {

        if(action.sowingId) {

            return 'Zaaibehandeling';
        }

        if(action.harvestId) {

            return 'Oogstbehandeling';
        }

        return 'Behandeling';
    }

    if(type === ActionType.SOWING) {

        return 'Zaaiing';
    }

    return 'Monstering';
}
